const TableData = [
  {
    dataheading: "CURRENT ASSETS",
    currentassets: "₹1,45,380.00",
    cash: "₹59,000",
    accountReceivable: "₹45,000.00",
    inventry: "₹31,000.00",
    prepaidExpense: "₹5,380.00",
  },
];

const Liability = [
  {
    currentLibilities: "₹1,45,380.00",
    accountPayable: "₹59,000",
    creditcardDept: "₹45,000.00",
    bankoperatingCredit: "₹31,000.00",
    AccuredExpences: "₹5,380.00",
    taxesPayable: "₹5,380.00",
  },
];

export  { TableData }
export  { Liability }
